import { createSelector } from '@ngrx/store';

import { getImagesForOnlineMenuPage } from '../getImagesForOnlineMenuPage';

export const getImageForOnlineMenuPageProduct = (pageId: number, pageProductId: number) =>
    createSelector(getImagesForOnlineMenuPage(pageId), (pageImages) => pageImages?.data?.find((image) => image.ParentId === pageProductId) || null);
